const value = {
    learningTitle: 'Знания',
    skillsMap: 'Карта компетенций',
    usersRating: 'Рейтинг участников',
    findByContext: 'Поиск контекста, юнита',
    showUnits: 'Показывать юниты',
  };

export default value;
